import { render, staticRenderFns } from "./SaitenInputExplanationPdf.vue?vue&type=template&id=f4085a2c&"
import script from "./SaitenInputExplanationPdf.vue?vue&type=script&lang=ts&"
export * from "./SaitenInputExplanationPdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports